/**
 * [리프레시 실패 분류] — P1-B.
 *
 * 토큰 리프레시(`/api/auth/refresh`) 실패를 두 종류로 나눈다:
 *   - transient(일시적): 네트워크 단절(fetch reject=null)·5xx·429·408 — 재시도하면 회복 가능.
 *   - definitive(확정): 그 외 4xx(401/403/400/404 등) — 세션이 실제로 무효 → 재시도 무의미.
 *
 * 라이브 회의 중 잠깐의 오프라인/프록시 502 로 definitive 로그아웃(하드 리다이렉트)을 하면
 * 회의가 끊긴다. transient 는 clear/redirect 없이 백오프 재시도로 버틴다(P1-B 핵심).
 */

export type RefreshFailureKind = 'transient' | 'definitive';

/** 리프레시 결과: 성공이거나, 실패면 종류를 담는다. */
export type RefreshOutcome = { ok: true } | { ok: false; kind: RefreshFailureKind };

/**
 * HTTP 상태코드(또는 네트워크 오류=null)를 리프레시 실패 종류로 분류한다(순수).
 *
 * @param status  응답 상태코드. fetch 자체가 reject(네트워크 단절)면 null.
 * @returns transient(재시도 가치 있음) | definitive(세션 무효, 로그아웃)
 */
export function classifyRefreshFailure(status: number | null): RefreshFailureKind {
  if (status === null) return 'transient'; // 네트워크 단절/타임아웃 — fetch reject
  if (status >= 500) return 'transient'; // 5xx: 업스트림/프록시 일시 장애
  if (status === 429 || status === 408) return 'transient'; // rate-limit / request timeout
  return 'definitive'; // 그 외 4xx: 토큰 무효/만료 확정
}
